import React from 'react';
import styles from './CodeRender.module.css';
import { useUIStore } from '../../stores/uiStore';
import CopyToClipboard from './CopyToClipboard';

interface CodeRenderProps extends React.HTMLAttributes<HTMLElement> {
  inline?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const CodeRender: React.FC<CodeRenderProps> = ({ inline, className, children, ...props }) => {

  const extractTextFromChildren = (children: React.ReactNode): string => {
    if (typeof children === 'string') return children;
    if (Array.isArray(children)) {
      return children.map(extractTextFromChildren).join('');
    }
    if (React.isValidElement(children)) {
      const element = children as React.ReactElement<any, any>;
      return extractTextFromChildren(element.props.children);
    }
    return '';
  }

  const { setOpenModalCode } = useUIStore();
  const codeString = extractTextFromChildren(children);
  const isMultiline = codeString.includes('\n');

  if (inline || (!className && !isMultiline)) {
    return <code className={className} {...props}>{children}</code>;
  }

  return (
    <div className={styles.codeBlockContainer}>
      <pre
        className={`${className} ${styles.codeBlock}`}
        {...props}
        onClick={() => setOpenModalCode(codeString)}
      >
        <code>{children}</code>
      </pre>
      <CopyToClipboard position={'default'} codeString={codeString} />
    </div>
  );
};

export default CodeRender;
